import { Search, Calendar, Play } from 'lucide-react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import courseListingScreen from 'figma:asset/b50c4dc45f2b188762bdc690eecadeca7f9927b9.png';
import teeTimeScreen from 'figma:asset/885346ad238de236908ad0c3601788acb32e4852.png';
import courseDetailScreen from 'figma:asset/4a3c26c7194fade8cae28a08c15c4c31b604fb93.png';

export function HowItWorksPlayers() {
  const steps = [
    {
      icon: Search,
      title: 'find a course',
      description: 'browse private disc golf courses near you with detailed info and photos'
    },
    {
      icon: Calendar,
      title: 'book a tee time',
      description: 'reserve your spot with instant confirmation and secure payment'
    },
    {
      icon: Play,
      title: 'play & enjoy',
      description: 'show up and play on exclusive courses with friends or solo'
    }
  ];

  return (
    <section id="players" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground lowercase mb-4">
            how it works for <span className="text-primary">players</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            discover and book amazing private disc golf courses in just a few taps
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Steps */}
          <div className="space-y-8">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div
                  key={index}
                  className="flex items-start space-x-4 group hover:bg-accent/50 p-4 rounded-2xl transition-all duration-300"
                >
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all duration-300">
                      <Icon className="w-6 h-6 text-primary group-hover:text-white" />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-foreground lowercase">
                      {index + 1}. {step.title}
                    </h3>
                    <p className="text-muted-foreground">{step.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Mobile App Screenshots */}
          <div className="relative">
            <div className="grid grid-cols-3 gap-3 lg:gap-4">
              {/* Course Listing Screen */}
              <div className="transform rotate-1 hover:rotate-0 transition-transform duration-300">
                <div className="bg-white rounded-2xl lg:rounded-3xl p-2 lg:p-3 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                  <div className="aspect-[9/19] rounded-xl lg:rounded-2xl overflow-hidden">
                    <img
                      src={courseListingScreen}
                      alt="Course Discovery - Browse available disc golf courses"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* Tee Time Selection Screen */}
              <div className="transform -rotate-1 hover:rotate-0 transition-transform duration-300 mt-4 lg:mt-8">
                <div className="bg-white rounded-2xl lg:rounded-3xl p-2 lg:p-3 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                  <div className="aspect-[9/19] rounded-xl lg:rounded-2xl overflow-hidden">
                    <img
                      src={teeTimeScreen}
                      alt="Tee Time Selection - Choose your preferred date and time"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* Course Detail Screen */}
              <div className="transform rotate-1 hover:rotate-0 transition-transform duration-300 mt-2 lg:mt-4">
                <div className="bg-white rounded-2xl lg:rounded-3xl p-2 lg:p-3 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                  <div className="aspect-[9/19] rounded-xl lg:rounded-2xl overflow-hidden">
                    <img
                      src={courseDetailScreen}
                      alt="Course Details - View course information and amenities"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Background Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary/10 rounded-full blur-xl" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-accent blur-xl" />
          </div>
        </div>
      </div>
    </section>
  );
}